export default __webpack_public_path__ + "static/media/minus_button.9ff5750e.png";